import "@/site.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { en } from "@/i18n/en";
import { el } from "@/i18n/el";
import { legalEn } from "@/i18n/legal.en";
import { legalEl } from "@/i18n/legal.el";
import { Shell } from "@/components/site/Shell";
import { Home } from "@/components/site/Home";
import { LegalPage, DeletePage } from "@/components/site/LegalPages";

const LANGS = [
  { prefix: "", dict: en, legal: legalEn },
  { prefix: "/el", dict: el, legal: legalEl },
];

const PAGES = [
  { paths: ["/privacy", "/privacy-policy"], slug: "/privacy", doc: "privacy" },
  { paths: ["/terms"], slug: "/terms", doc: "terms" },
  { paths: ["/delete-account"], slug: "/delete-account", doc: "deletion" },
];

const pageRoutes = LANGS.flatMap((l) =>
  PAGES.flatMap((p) =>
    p.paths.map((path) => (
      <Route
        key={l.prefix + path}
        path={l.prefix + path}
        element={
          <Shell lang={l} slug={p.slug} meta={l.legal[p.doc].meta}>
            {p.doc === "deletion" ? <DeletePage /> : <LegalPage doc={p.doc} />}
          </Shell>
        }
      />
    ))
  )
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {pageRoutes}
        <Route path="/el" element={<Shell lang={LANGS[1]}><Home /></Shell>} />
        <Route path="*" element={<Shell lang={LANGS[0]}><Home /></Shell>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
